export default () =>
  (navigator.language || navigator.systemLanguage || navigator.userLanguage || navigator.languages[0])
    .substr(0, 2)
    .toLowerCase();



// WEBPACK FOOTER //
// ./utils/languageDetector.js